(function($) {
    var $form = $('#register-training-form'),
        $zipcode = $form.find('[name="participant_zipcode"]'),
        $housenumber = $form.find('[name="participant_house_number"]'),
        $address = $form.find('[name="participant_address"]'),
        $city = $form.find('[name="participant_city"]'),
        getAddress = debounce(function(data) {
            $city.val(data.city);
            $address.val(data.street);
        }, 300);

    function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

    $form.on('keyup', '[name="participant_zipcode"], [name="participant_house_number"]', function(e) {
        var zipcode = $zipcode.val(),
            housenumber = $housenumber.val();

        if(zipcode && housenumber) {
            $.getJSON( "//api.postco.de/v1/postcode/" + zipcode + "/" + housenumber)
            .done(getAddress)
            .fail(function(jqxhr, textStatus, error){
                var err = textStatus + ', ' + error;

                $city.val('');
                $address.val('');

                console.log('Request Failed: ' + err);
            });
        }
    });
})(jQuery);